import { ReportTimeIntervalType } from '@vision/ui/enums';
import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { TrendChart1CompareRenderer } from '../../../components';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../../default-chart.config';
import { ExTrendChart1Measures } from './ex-trend-chart1.measures';

export const ExTrendChart1DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({}),
  measures: ExTrendChart1Measures,
  compareRendererComponent: TrendChart1CompareRenderer,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    timeInterval: ReportTimeIntervalType.DAY,
    transactionalDate: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    xAxis: {
      ...DefaultReportChartThemeFont,
    },
    yAxis: {
      ...DefaultReportChartThemeFont,
      activeDisplayFormat: true,
      displayFormat: 'auto',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      displayFormat: 'auto',
      position: 'top',
    },
    serieDot: {
      active: false,
      symbolSize: 6,
      symbolType: 'circle',
      symbolFilling: 'full',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
